// Presentation only: never change persisted game/series results.
const key = value => String(value || '').toLowerCase();
function time(value) {
  if (value == null || value === '') return 0;
  const result = typeof value === 'number' ? value : Date.parse(value);
  return Number.isFinite(result) ? result : 0;
}
function gameTime(game) {
  return time(game.endedAt) || time(game.endTime) || time(game.finishedAt) || time(game.date);
}
function seriesTime(series) {
  return Math.max(time(series.withdrawal?.at), ...series.rounds.map(round => time(round.endedAt)), 0);
}
function finishedTimeline(games, series) {
  const knownRounds = new Set(series.flatMap(s => s.rounds.map(r => r.gameId)));
  const knownSeries = new Set(series.map(s => s.id));
  const entries = series.filter(s => s.phase === 'completed').map(s => ({kind:'series',id:s.id,date:seriesTime(s),series:s}));
  for (const game of games) {
    // Hide rounds only when their parent series is available. Failed series requests
    // must not make historic matches disappear.
    if (knownRounds.has(game.gameId) || knownSeries.has(game.duelId || game.duel?.id)) continue;
    entries.push({kind:'game',id:game.gameId,date:gameTime(game),game});
  }
  return entries.sort((a,b) => b.date - a.date || String(a.id).localeCompare(String(b.id)));
}
function resultFor(game, username) {
  const me = key(username), winner = key(game.winner), loser = key(game.loser);
  if (winner) return winner === me ? 'Kazandın' : 'Kaybettin';
  if (loser === me) return 'Kaybettin';
  if (game.isDraw || game.result === 'Draw') return 'Beraberlik';
  const own = Object.keys(game.finalScores || {}).find(p => key(p) === me);
  const other = Object.keys(game.finalScores || {}).find(p => key(p) !== me);
  const a = game.finalScores?.[own], b = game.finalScores?.[other];
  return a != null && b != null ? a > b ? 'Kazandın' : a < b ? 'Kaybettin' : 'Beraberlik' : 'Sonuç kayıtlı değil';
}
module.exports = {finishedTimeline, gameTime, seriesTime, resultFor};
